import FaqAccordion from "./components/FaqAccordion";
import "./App.css";

function App() {
	return (
		<div className="App">
			<FaqAccordion />
		</div>
	);
}

export default App;
